<template>
	<v-container grid-list-lg>
        <v-layout wrap>
            <v-flex xs12 v-if="capabilitiesSet">
				<v-alert v-if="onGenericTrial" type="warning" :class="{ 'theme--light' : !darks.warning }" class="mb-0" dismissible>
					Your trial expires {{ trialDaysRemaining }}. Any users, departments or features not in the plan you choose will be removed.
				</v-alert>
				<v-alert v-else-if="!$store.state.activePlan && spark.state.currentTeam" type="error" :class="{ 'theme--light' : !darks.error }" class="mb-0">
					Your trial has expired and you are not subscribed to a plan. Choose a plan to get started.
				</v-alert>
				<v-slide-x-reverse-transition mode="out-in">
				    <router-view :key="$route.path" :user="user" :teams="teams" @reloadData="loadMetadata"></router-view>
				</v-slide-x-reverse-transition>
				<core-modals></core-modals>
            </v-flex>
        </v-layout>

		<v-snackbar
			:timeout="3000"
			:color="snackbar.state"
			v-model="snack"
			:top="true"
			:right="true">
			{{ snackbar.text }}
		</v-snackbar>
    </v-container>
</template>

<script>
	import CoreModals from './modals';
	import theming from '../../mixins/theming';

    export default {
        data() {
            return {
				capabilitiesSet: false,
				snack: false,
				departmentsloaded: false,
				currentTeamId: this.user.current_team_id
			}
        },
        components: {
			'core-modals' : CoreModals
		},
		computed: {
			// loaded() {
			// 	return Object.keys(this.$store.state.capabilities[this.user.current_team_id]).length ? true : false;
			// },
			snackbar() {
				return this.$store.state.snackbar;
			},
			trialDaysRemaining() {
				let days = 0;
				if(this.onGenericTrial){
					days = moment.utc(this.spark.state.currentTeam.trial_ends_at).fromNow();
				}
				return days;
			}
		},
		created() {
			if(this.spark.state.currentTeam){
				if(this.spark.state.currentTeam.status === 'installation')
					this.$router.push('/setup');

				Promise.all([
					this.$store.dispatch('setCapabilities', { user: this.user, teams: this.teams }),
					this.$store.dispatch('setActiveplan')
				]).then(result => {
					this.capabilitiesSet = true;
					this.loadTheme();
					this.loadMetadata();
					window.Echo.private('orders.'+this.user.current_team_id).listen('OrderUpdated', (e) => {
						this.$store.dispatch('orderUpdated', e);
					});
				})
				.catch(error => {
					console.log(error);
				});
			}else{
				this.capabilitiesSet = true;
				this.$router.push('/teams/missing');
			}
		},
		methods: {
			goHome() {
				if(this.departmentsloaded && (this.$store.state.activePlan || this.onGenericTrial)){
					if(this.$store.state.departments.length){
						this.$router.push('department/'+this.$store.state.departments[0].id);
					}else if(this.$store.state.activePlan){
						this.$router.push('config');
					}
				}
			},
			loadMetadata() {
				let promises = [],
					teamconfig = JSON.parse(this.spark.state.currentTeam.configuration);
				promises.push(this.$store.dispatch('loadfields'));
				if(this.iCan('view', 'Exports'))
					promises.push(this.$store.dispatch('load', 'exports'));
				if(this.iCan('view', 'Reports'))
					promises.push(this.$store.dispatch('load', 'reports', this.myExcludes('Reports')));
				promises.push(this.$store.dispatch('load', 'customers'));
				promises.push(this.$store.dispatch('load', 'departments').then(() => {
					this.departmentsloaded = true;
					if(this.$route.path === '/'){
						this.goHome()
					}
				}));
				promises.push(this.$store.dispatch('load', 'posttypes'));
				promises.push(this.$store.dispatch('load', 'posttype_items'));
				promises.push(this.$store.dispatch('load', 'pricetypes'));
				promises.push(this.$store.dispatch('load', 'products'));
				promises.push(this.$store.dispatch('load', 'roles'));
				if(teamconfig.dashboards)
					this.$store.dispatch('set', { name: 'dashboards', value: teamconfig.dashboards });
				Promise.all(promises).then(result => {
					this.$store.dispatch('set', { name: 'dataloaded', value: true });
				}).catch(error => console.log(`Error in promises ${error}`));

				if(!this.$store.state.activePlan && !this.onGenericTrial && this.$route.path === '/'){
					this.$router.push('settings/team/'+this.spark.state.currentTeam.id);
				}
			}
		},
		mixins: [ theming ],
        props: ['user', 'teams'],
		watch: {
			'$route'() {
				if(this.$route.path === '/'){
					this.goHome();
				}
			},
			snackbar: {
				deep: true,
				handler: function(snackbar) {
					this.snack = true;
				}
			},
			user: {
				deep: true,
				handler: function(user) {
					if(user.current_team_id !== this.currentTeamId){
						window.location = "/";
					}
				}
			}
		}
    }
</script>
